import { TMenuBranch } from '../components/types';
import { DASHBOARD_MENU } from './dashboards';
import { CONVERSATIONS_MENU } from './conversation';
import { MANAGEMENT_MENU } from './management';
import { BarChart, PieChart, Settings } from 'react-feather';
import { MessageCircle } from 'react-feather';
import { Database } from 'react-feather';
import { REPORTS_MENU } from './reports';
import { SETTINGS_MENU } from './settings';

export const MENU_ITEMS: TMenuBranch[] = [
    {
        title: 'Navbar.Dashboard',
        items: DASHBOARD_MENU,
        Icon: PieChart,
    },
    {
        title: 'Navbar.Conversations',
        items: CONVERSATIONS_MENU,
        Icon: MessageCircle,
    },
    {
        title: 'Navbar.Principal',
        items: MANAGEMENT_MENU,
        Icon: Database,
    },
    {
        title: 'Navbar.Analytics',
        items: REPORTS_MENU,
        Icon: BarChart,
    },
    {
        title: 'Navbar.Settings',
        items: SETTINGS_MENU,
        Icon: Settings,
    },
];
